"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MainImage = _interopRequireDefault(require("./MainImage.vue"));
var _enum = require("../../enum");
var _permission = require("@/utils/permission");
var _systemSetting = require("@/api/systemSetting");
var _internal = require("@/components/uploadPicture/internal.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'goodsAttrBuit',
  components: {
    MainImageVue: _MainImage.default
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      attrProps: [],
      goodsStatusEnum: _enum.goodsStatusEnum,
      cpStatusEnum: _enum.cpStatusEnum,
      attrValue: this.list,
      changeIndex: null
    };
  },
  watch: {
    list: {
      handler: function handler(val) {
        this.attrValue = val;
      },
      deep: true
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    updataAttrProps: function updataAttrProps(data) {
      this.attrProps = data;
    },
    deleteRecord: function deleteRecord(index) {
      this.attrValue.splice(index, 1);
    },
    // 添加表格验证方法
    validate: function validate() {
      if (!this.attrValue || this.attrValue.length === 0) {
        this.$message.error('商品属性表格不能为空');
        console.error('商品属性表格验证失败: 表格为空');
        return false;
      }
      var requiredFields = [{
        field: 'attrImage',
        name: '规格图片'
      }, {
        field: 'image',
        name: '主图管理',
        isArray: true
      }, {
        field: 'skuName',
        name: 'SKU名称'
      }, {
        field: 'skuCode',
        name: 'SKU编码'
      }, {
        field: 'barCode',
        name: '条形码'
      }, {
        field: 'otPrice',
        name: '原价'
      }, {
        field: 'supplyPrice',
        name: '代发成本价'
      },
      // { field: 'cpSupplyPrice', name: '集采供货价' },
      // { field: 'cpMinQuantity', name: '集采起订量' },
      {
        field: 'stock',
        name: '库存数量'
      }, {
        field: 'stockWarning',
        name: '库存预警量'
      }, {
        field: 'cpStatus',
        name: '采销状态'
      }, {
        field: 'listStatus',
        name: '上下架状态'
      }];
      for (var i = 0; i < this.attrValue.length; i++) {
        var row = this.attrValue[i];
        console.log("\u9A8C\u8BC1\u7B2C ".concat(i + 1, " \u884C\u6570\u636E:"), row);

        // 检查每个属性值是否为空
        for (var key in row.attrValue) {
          if (!row.attrValue[key]) {
            this.$message.error("\u7B2C ".concat(i + 1, " \u884C\u7684 ").concat(key, " \u4E0D\u80FD\u4E3A\u7A7A"));
            console.error("\u89C4\u683C\u5C5E\u6027\u9A8C\u8BC1\u5931\u8D25: \u7B2C ".concat(i + 1, " \u884C\u7684 ").concat(key, " \u4E3A\u7A7A"));
            return false;
          }
        }

        // 检查必填字段
        var errorFields = [];
        var _iterator = _createForOfIteratorHelper(requiredFields),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var value = row[item.field];
            if (item.isArray) {
              // 数组类型字段的验证
              if (!value || !Array.isArray(value) || value.length === 0) {
                errorFields.push(item.name);
              }
              // 专门针对主图的验证，确保至少有3张图片
              else if (item.field === 'image' && value.length < 3) {
                this.$message.error("\u7B2C ".concat(i + 1, " \u884C\u7684").concat(item.name, "\u5FC5\u987B\u4E0A\u4F203\u5F20\u6216\u4EE5\u4E0A"));
                console.error("\u4E3B\u56FE\u9A8C\u8BC1\u5931\u8D25: \u7B2C ".concat(i + 1, " \u884C\u7684\u4E3B\u56FE\u6570\u91CF\u4E0D\u8DB33\u5F20"));
                return false;
              }
            } else {
              // 普通字段验证
              if (value === undefined || value === null || value === '') {
                errorFields.push(item.name);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (errorFields.length > 0) {
          this.$message.error("\u7B2C ".concat(i + 1, " \u884C\u7684\u4EE5\u4E0B\u5FC5\u586B\u9879\u672A\u586B\u5199: ").concat(errorFields.join(', ')));
          console.error("\u89C4\u683C\u5E93\u5B58\u9A8C\u8BC1\u5931\u8D25: \u7B2C ".concat(i + 1, " \u884C\u7F3A\u5C11\u5B57\u6BB5: ").concat(errorFields.join(', ')));
          return false;
        }
      }
      console.log('规格库存验证通过');
      return true;
    },
    attrImage: function attrImage(index) {
      var _this = this;
      (0, _internal.uploadLocalImage)({
        multiple: false,
        model: 'product',
        pid: 1,
        validateAspectRatio: true,
        // 确保验证1:1比例
        onSuccess: function onSuccess(url) {
          var _this$attrValue;
          // 上传成功，添加到图片列表
          var arr = _toConsumableArray(_this.attrValue);
          arr[index].attrImage = url;
          (_this$attrValue = _this.attrValue).splice.apply(_this$attrValue, [0, _this.attrValue.length].concat(_toConsumableArray(arr))); //强制更新数组
          _this.$message.success('规格图片上传成功');
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '图片上传失败');
        }
      });
    },
    handleMainImage: function handleMainImage(row, index) {
      this.changeIndex = index;
      this.$refs.mainImageRef.open(row.image);
    },
    mainImageList: function mainImageList(data) {
      this.$set(this.attrValue[this.changeIndex], 'image', data);
    },
    // 计算毛利率
    calculateProfit: function calculateProfit(row, index) {
      // 毛利率自动计算：(原价-供货价)/原价*100
      var otPrice = row.otPrice,
        supplyPrice = row.supplyPrice;
      if (Number(otPrice) && Number(supplyPrice)) {
        var grossMargin = ((otPrice - supplyPrice) / otPrice * 100).toFixed(2);
        this.attrValue[index].grossMargin = grossMargin;
        return grossMargin;
      } else {
        this.attrValue[index].grossMargin = 0;
        return 0;
      }
    },
    changeCpStatus: function changeCpStatus(index) {
      var cpStatus = this.attrValue[index].cpStatus;
      if (cpStatus !== 3) {
        this.$set(this.attrValue[index], 'listStatus', '');
      }
    },
    // 只有已入库才能上架
    changeListStatus: function changeListStatus(index) {
      var _this$attrValue$index = this.attrValue[index],
        cpStatus = _this$attrValue$index.cpStatus,
        listStatus = _this$attrValue$index.listStatus;
      if (cpStatus !== 3 && listStatus === 1) {
        this.$message.warning('只有已入库才能上架');
        this.$set(this.attrValue[index], 'listStatus', '');
      }
    }
  }
};